import React from 'react';

const LandingImpact = () => {
  const impactPoints = [
    "Promoting awareness of social and mental health issues",
    "Supporting youth and adolescents through education and mentorship",
    "Advocating for women's rights and gender equality",
    "Strengthening community capacity through training and development programs"
  ];

  return (
    <section className="landing-impact" id="impact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Impact</h2>
          <p className="section-subtitle">Making a Difference</p>
        </div>
        <div className="impact-content">
          <div className="impact-statement-box">
            <p className="impact-statement-text">
              A world where no survivor of violence suffers in silence and everyone has access to compassionate support and healing.
            </p>
          </div>
          <div className="impact-about-section">
            <div className="impact-points">
              {impactPoints.map((point, index) => (
                  <div className="impact-point" key={index}>
                    <div className="impact-check">✓</div>
                    <p>{point}</p>
                  </div>
              ))}
            </div>
          </div>
          {/*<div className="impact-intro">*/}
          {/*  <div className="impact-goal">*/}
          {/*    <p>*/}
          {/*      Our goal is to empower communities to become more resilient, informed, and capable of driving their own development.*/}
          {/*    </p>*/}
          {/*  </div>*/}
          {/*</div>*/}


        </div>
      </div>
    </section>
  );
};

export default LandingImpact;
